import styled from 'styled-components';

interface SkeletonLoaderProps {
  className?: string;
  variant?: 'primary' | 'secondary';
}
export const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({ className, variant = 'primary' }) => (
  <S.Loader className={className} variant={variant} />
);

const S = {
  Loader: styled.div<{ variant: 'primary' | 'secondary' }>`
    overflow: hidden;
    mask-image: radial-gradient(white, black);
    background-color: ${({ variant, theme }) => theme.loadingGradient[variant].mainColor};

    &::after {
      display: block;
      content: '';
      width: 100%;
      height: 100%;
      transform: translateX(-100%);
      animation: loading 2s infinite;
      background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0),
        ${({ variant, theme }) => theme.loadingGradient[variant].shadowColor},
        rgba(255, 255, 255, 0)
      );
    }
    @keyframes loading {
      100% {
        transform: translateX(100%);
      }
    }
  `,
};
